import { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Play, Pause, DownloadSimple } from '@phosphor-icons/react'

import { handleDownload, formatTime } from './helpers'

const AudioPlayer = ({ recordingUrl }) => {
  const [isPlaying, setIsPlaying] = useState(false)
  const [currentTime, setCurrentTime] = useState(0)
  const [duration, setDuration] = useState(0)
  const audioRef = useRef(null)

  useEffect(() => {
    const audioElement = audioRef.current
    const onLoadedMetadata = () => {
      setDuration(audioElement.duration)
    }

    const onTimeUpdate = () => {
      setCurrentTime(audioElement.currentTime)
    }

    audioElement.addEventListener('loadedmetadata', onLoadedMetadata)
    audioElement.addEventListener('timeupdate', onTimeUpdate)

    return () => {
      audioElement.removeEventListener('loadedmetadata', onLoadedMetadata)
      audioElement.removeEventListener('timeupdate', onTimeUpdate)
    }
  }, [])

  const togglePlay = () => {
    const audioElement = audioRef.current
    if (isPlaying) {
      audioElement.pause()
    } else {
      audioElement.play()
    }
    setIsPlaying(!isPlaying)
  }

  const progress = (currentTime / duration) * 100

  return (
    <div className="media-control">
      <audio ref={audioRef} src={recordingUrl} />
      <button onClick={togglePlay} className="media-player-btn">
        {isPlaying ? (
          <Pause className="media-control__play-icon" size={12} weight="fill" />
        ) : (
          <Play className="media-control__play-icon" size={12} weight="fill" />
        )}
      </button>
      <span className="time">
        {formatTime(currentTime)} / {formatTime(duration)}
      </span>

      <div className="progress-bar">
        <div className="progress" style={{ width: `${isNaN(progress) ? 0 : progress}%` }} />
      </div>
      <button onClick={() => handleDownload(recordingUrl)} className="media-player-btn">
        <DownloadSimple className="media-player__icon" size={16} />
      </button>
    </div>
  )
}

export default AudioPlayer

AudioPlayer.propTypes = {
  recordingUrl: PropTypes.string,
}
